import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, NgModule, Input } from '@angular/core';
import { ClientStatus } from '@fitness-force/enum';
import { AgePipe } from 'libs/shared/src/lib/filters/age.pipe';
import { DayAgoPipe } from 'libs/shared/src/lib/filters/dayago.pipe';
import { TimeLinePipe } from 'libs/shared/src/lib/filters/timeline.pipe';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'age-cell',
  templateUrl: './age-cell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    AgePipe,
  ]
})
export class AgeCellComponent implements OnInit {
  @Input() columnData = new BehaviorSubject(null)
  @Input() additionData = new BehaviorSubject(null)

  constructor() { }

  ngOnInit(): void {
  }

  isMebersStatus(data:any)
  {
    var clientStatus = ClientStatus[data.client_status as keyof typeof ClientStatus];
    if(clientStatus == ClientStatus.Client) return true;
    else return true;
  }
}
